import { Action } from '@ngrx/store'
import { User } from '../models'

export const SET_CURRENT_USER = '[User] Set Current User'

export class SetCurrentUser implements Action {
  readonly type = SET_CURRENT_USER

  constructor(public user: User) { }
}

export type All = SetCurrentUser



// WEBPACK FOOTER //
// ./src/actions/user.ts